import Hero from "../components/Hero"
import RestaurantStory from "../components/RestaurantStory"

const About = () => {
    return (
      <>
        <main className="about-page">
          <RestaurantStory />
        </main>
      </>
    );
}
export default About